var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecontract(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12.06 19V16.99C12.04 16.99 12.02 16.99 12 16.99C10.72 16.99 9.44 16.5 8.46 15.53C6.75 13.82 6.54 11.18 7.82 9.24L8.92 10.34C8.21 11.67 8.39 13.35 9.51 14.47C10.21 15.17 11.13 15.5 12.05 15.48V13.34L14.88 16.17L12.06 19ZM16.17 14.76L15.07 13.66C15.78 12.33 15.6 10.65 14.48 9.53C13.79 8.84 12.9 8.5 12 8.5C11.98 8.5 11.96 8.5 11.94 8.5V10.65L9.11 7.83L11.94 5V7.02C13.24 7 14.55 7.47 15.54 8.47C17.24 10.17 17.45 12.82 16.17 14.76Z",
    fill: "#0288D1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecontract);
export default __webpack_public_path__ + "static/media/recontract.f515bc71c24547a5e361ee659f8fed4e.svg";
export { ForwardRef as ReactComponent };